export default "__VITE_ASSET__BUNqs6HC__"